import { TComponentName } from "../../types/common/components.types";

type TComponentChildren = {
  [name in TComponentName]: TComponentName[] | null;
};

export const COMPONENT_CHILDREN: TComponentChildren = {
  XPage: ["XStack", "XGrid", "XCarousel", "XCategoryFilter", "XProductDetails"],
  XHeader: null, // TODO IMPLEMENT ["XStack", "XGrid"],
  XFooter: ["XStack", "XGrid"],
  XArticle: ["XGrid", "XStack", "XText", "XButton"], // MORE COMPONENT TO ADD (XRating, ColorPicker, etc...)

  // CONTAINERS
  XStack: [
    "XStack",
    "XText",
    "XButton",
    "XBreadcrumb",
    "XImage",
    "XLink",
    "XRating",
    "XMap",
    "XForm",
    "XIcon",
  ],
  XGrid: ["XGrid", "XStack", "XCarousel", "XImage"],
  XCarousel: ["XStack", "XImage"],
  XCategoryFilter: [],
  XProductDetails: [],

  // ELEMENT
  XText: null,
  XButton: null,
  XLink: null,
  XImage: null,
  XBreadcrumb: null,
  XCategoryList: null,
  XColorPicker: null,
  XForm: null,
  XOptionChoice: null,
  XPricing: null,
  XRating: null,
  XIcon: null,
  XMap: null,
  XSearch: null,
};

export const UN_DELETABLE_COMPONENT: TComponentName[] = [
  "XArticle",
  "XFooter",
  "XHeader",
];

export const COMPONENT_WITH_API_FETCH: TComponentName[] = [
  "XGrid",
  "XCarousel",
  "XCategoryFilter",
];
